// extracted by mini-css-extract-plugin
export default {"badge_document":"CardImage_badge_document__ewpkK","img_document":"CardImage_img_document__DVXTS"};